import { RouteConfig } from 'vue-router';
import NfrService from './nfr-service.vue';
import NfrServiceHistory from './components/nfr-service-history.vue';
export const nfrServiceRoute : RouteConfig = {
  path : 'nfrrequest',
  component : NfrService,
};

export const nfrServiceHistoryRoute : RouteConfig = {
  path : 'nfrhistory',
  component : NfrServiceHistory,
};

// export function getDefaultParam() {
//   return  {};
// }

// export default nfrServiceRoute;
